// extracted by mini-css-extract-plugin
export default {"addressMainContent":"B9naG"};